import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faAlien8bit,
  faArrowLeft,
  faArrowsFromLine,
  faArrowsToLine,
  faBookOpenCover,
  faBooks,
  faCamera,
  faChalkboardUser,
  faChevronRight,
  faCircle,
  faCircleInfo,
  faCircleNodes,
  faDownload,
  faEdit,
  faExclamationTriangle,
  faFaceLaughBeam,
  faFile,
  faFileCertificate,
  faFileDoc,
  faFileExport,
  faFilePdf,
  faFileSpreadsheet,
  faFilter,
  faFolder,
  faGauge,
  faHand,
  faHeadSideGoggles,
  faImage,
  faKey,
  faList,
  faMagnifyingGlass,
  faMedal,
  faOtter,
  faPaperPlane,
  faPenField,
  faPersonChalkboard,
  faPersonRunning,
  faPlus,
  faPresentationScreen,
  faQuestionCircle,
  faRobot,
  faScreenUsers,
  faSignsPost,
  faSitemap,
  faSlashForward,
  faSwap,
  faTrashCan,
  faUpload,
  faUserGear,
  faUserHardHat,
  faUserHeadset,
  faUserLock,
  faUserPlus,
  faUsers,
  faUsersGear,
  faUserXmark,
  faVideo,
  faXmark,
} from "@fortawesome/pro-light-svg-icons";

export const initLightIcons = () => {
  library.add(
    faAlien8bit,
    faArrowLeft,
    faArrowsFromLine,
    faArrowsToLine,
    faBookOpenCover,
    faBooks,
    faCamera,
    faChalkboardUser,
    faChevronRight,
    faCircle,
    faCircleInfo,
    faCircleNodes,
    faDownload,
    faEdit,
    faExclamationTriangle,
    faFaceLaughBeam,
    faFile,
    faFileCertificate,
    faFileDoc,
    faFileExport,
    faFilePdf,
    faFileSpreadsheet,
    faFilter,
    faFolder,
    faGauge,
    faHand,
    faHeadSideGoggles,
    faImage,
    faKey,
    faList,
    faMagnifyingGlass,
    faMedal,
    faOtter,
    faPaperPlane,
    faPenField,
    faPersonChalkboard,
    faPersonRunning,
    faPlus,
    faPresentationScreen,
    faQuestionCircle,
    faRobot,
    faScreenUsers,
    faSignsPost,
    faSitemap,
    faSlashForward,
    faSwap,
    faTrashCan,
    faUpload,
    faUserGear,
    faUserHardHat,
    faUserHeadset,
    faUserLock,
    faUserPlus,
    faUserXmark,
    faUsers,
    faUsersGear,
    faVideo,
    faXmark,
  );
};
